window.DocTools = {

	purDoctype		: new Array("purOrder","purDelivery", "purInvoice", "purModel", 'purCreditNote'),
	preFormWidth	: 1024,

	createForThird: function(doctype, title, withThird, items, thirdId){

		withThird	= withThird == undefined ? true : withThird;
		items		= items == undefined ? "" : items;
		if(Utils.in_array(doctype,DocTools.purDoctype)) {
			var url = "purchases_purchases";
		}else {
			var url = "doc";
		}

		var options = {
            title	: title,
            dialogClass : 'white',
			buttons	: [
                {
					text : Loc.g("Annuler"),
					'data-bot': 'document-form--cancel',
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Créer le document"),
					'data-bot': 'document-form--create',
					click	: function(){

                        var doctype = $('#docCreateForThirdForm').find('#doctype').val();
                        if(doctype == 'order' && $('#docnewthird:checked').length == 0){
                            var third_id = $('#docCreateForThirdForm').find('#docsearchThird').val().split('_')[1];
                            window.SellsyJS.WebServiceCaller.get(`/rest/document/order/third/${third_id}/allowed`, {}, (response) => {
                                if(response.allowed){
                                    $("#docCreateForThirdForm").submit();
                                } else {
                                    $('#alert-client-not-allowed').show();
                                }
                            });
                        } else {
                            $("#docCreateForThirdForm").submit();
                        }

					}
				}
			],
			callback	: function(){
				DocTools.prepareCreateForThirdForm(url);
			},
			width	: DocTools.preFormWidth,
			height	: "auto"
		};
		var fileOpt = {
			action		:"createForThirdForm",
			doctype		: doctype,
			withThird	: (withThird ? 'Y' : 'N'),
			items		: items,
			thirdId		: thirdId
		};
		MyWindow.load(url, fileOpt, options);

	},

	createPurchaseFromSales: function(salesDoctype, salesDocid, doctype, title){

		var options = {
			title	: title,
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					click	: function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Créer le document"),
					click	: function(){
						$("#docCreateForThirdForm").submit();
					}
				}
			],
			callback	: function(){DocTools.prepareCreateForThirdForm("purchases_purchases");},
			width	: DocTools.preFormWidth,
			height	: "auto"
		};

		var fileOpt = {
			action			:"createForThirdForm",
			salesDoctype	: salesDoctype,
			salesDocid		: salesDocid,
			doctype			: doctype,
			withThird		: 'Y',
			fromSalesDoc	: 'Y'
		};
		MyWindow.load("purchases_purchases", fileOpt, options);

	},

	createSalesFromPurchases: function(purchasesDoctype, purchasesDocid, doctype, title){

		var options = {
			title	: title,
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					click	: function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Créer le document"),
					click	: function(){
                        var doctype = $('#docCreateForThirdForm').find('#doctype').val();
                        if(doctype == 'order' && $('#docnewthird:checked').length == 0){
                            var third_id = $('#docCreateForThirdForm').find('#docsearchThird').val().split('_')[1];
                            window.SellsyJS.WebServiceCaller.get(`/rest/document/order/third/${third_id}/allowed`, {}, (response) => {
                                if(response.allowed){
                                    $("#docCreateForThirdForm").submit();
                                } else {
                                    $('#alert-client-not-allowed').show();
                                }
                            });
                        } else {
                            $("#docCreateForThirdForm").submit();
                        }
					}
				}
			],
			callback	: function(){
				DocTools.prepareCreateForThirdForm("doc");
			},
			width	: DocTools.preFormWidth,
			height	: "auto"
		};

		var fileOpt = {
			action				:"createForThirdForm",
			purchasesDoctype	: purchasesDoctype,
			purchasesDocid		: purchasesDocid,
			doctype				: doctype,
			withThird			: 'Y',
			fromPurchasesDoc	: 'Y'
		};
		MyWindow.load("doc", fileOpt, options);

	},

	prepareCreateForThirdForm: function(action){
		var formId = "docCreateForThirdForm";
		var options = {
			data:		{
				action : 'recordCreateForThird'
			},
			success:	function(data) {
				DocTools.recordCreateForThirdCallback(data);
			},
			dataType:"json"
		};

		var docmetas = DocOverview.getProperties(['doctype']);
		if($('input#doctype').val() === ''){
			$('input#doctype').val(docmetas.doctype);
		}

	 	MyForm.prepare(formId, action, options, true);
		MyFacture.initEvent("#docCreateForThirdForm");

		DocTools.switchCreateForThird();

		$('.token-input-list').not($('#token-input-docmodel, #token-input-docnewfromDocid, #token-input-docnewfromPurid').parent().parent()).bind('click', function(){
			var radio = $(this).prev().find('input:radio');
			$('input:radio[name=po_linkedtype]:checked').removeAttr('checked');
			radio.attr('checked', true);
			MyFacture.customForm();
			DocTools.switchCreateForThird();
		});
	},

	recordCreateForThirdCallback: function(data){
		var formIsOk = MyForm.processJson(data, "docCreateForThirdForm");

		if(formIsOk && (data.rateCategory || Utils.in_array(data.doctype,DocTools.purDoctype))){
			if(data.thirdid == undefined && data.doctype != 'model'){
				return;
			}

			var docmetas = DocOverview.getProperties(['doctype', 'docid']);
			var relocateURL = data.doctype+"Form";

			if(data.rateCategory != undefined && data.applyThirdPrefs != 'Y') {
				relocateURL+= "&rateCategory="+data.rateCategory;
			}
			if(data.thirdid != undefined){
				relocateURL += "&for="+data.thirdid;
			}
			if(data.copy == 'Y' && docmetas.docid && docmetas.docid.length > 0){
				relocateURL += "&copyFrom="+docmetas.docid;
			}
			if(data.docmodel != undefined && data.docmodel>0){
				relocateURL += "&model="+data.docmodel;
			}
			if(data.updatePrices != undefined) {
				relocateURL += "&updatePrices="+data.updatePrices;
			}
			if(data.items != undefined){
				relocateURL += "&items="+data.items;
			}

			if(data.salesDoctype != undefined && data.salesDocid != undefined) {
				relocateURL += "&salesDoctype="+data.salesDoctype;
				relocateURL += "&from="+data.salesDocid;
			}

			if(data.purchasesDoctype != undefined && data.purchasesDocid != undefined) {
				relocateURL += "&purchasesDoctype="+data.purchasesDoctype;
				relocateURL += "&from="+data.purchasesDocid;
			}

			if(data.useEcotaxe != undefined) {
				relocateURL += "&useEcotaxe="+data.useEcotaxe;
			}

			if(data.doclayout != undefined) {
				relocateURL += "&doclayout="+data.doclayout;
			}

			if(data.doclang != undefined) {
				relocateURL += "&doclang="+data.doclang;
			}

			if(data.applyThirdPrefs != undefined) {
				relocateURL += "&applyThirdPrefs="+data.applyThirdPrefs;
			}

			if(data.vatMode != undefined && data.vatMode.length > 0) {
				relocateURL += "&vatMode="+data.vatMode;
			}

			if(Utils.in_array(data.doctype,DocTools.purDoctype)) {
				relocateURL = "purchases_"+relocateURL;
			}

			MyFacture.relocate(relocateURL);
		}
	},

	prepareToModelCallback: function() {
		var formId = "docCreateForThirdForm";
		var options = {
			data : {action : 'recordCreateForThird'},
			success:function(data){
				DocTools.recordToModelCallback(data);
			},
			dataType:"json"
		};

		var docmetas = DocOverview.getProperties(['doctype']);
		if($('input#doctype').val() === ''){
			$('input#doctype').val(docmetas.doctype);
		}

	 	MyForm.prepare(formId, "doc", options, true);
		MyFacture.initEvent("#docCreateForThirdForm");

		DocTools.switchCreateForThird();

		$('.token-input-list').bind('click', function(){
			var radio = $(this).prev().find('input:radio');
			$('input:radio[name=po_linkedtype]:checked').removeAttr('checked');
			radio.attr('checked', true);
			MyFacture.customForm();
			DocTools.switchCreateForThird();
		});
	},

	recordToModelCallback: function(data) {
		var formIsOk = MyForm.processJson(data, "docCreateForThirdForm");
		if(formIsOk && data.rateCategory){
			var docmetas = DocOverview.getProperties(['doctype', 'docid']);
			var relocateURL = data.doctype+"Form&rateCategory="+data.rateCategory+"&from="+docmetas.docid;
			MyFacture.relocate(relocateURL);
		}
	},


	switchCreateForThird: function(more){

		var $radioSelected	= $('#docthird_choice input[name=docthird]:checked');
		var checked			= $radioSelected.val();

		var formID, relationType, getForm;

		switch(checked) {
			case "newThird":
				formID			= 'newThirdForm';
				relationType	= 'client';
				getForm			= true;
				break;
			case "newProspect":
				formID			= 'newProspectForm';
				relationType	= 'prospect';
				getForm			= true;
				break;
			case "newSupplier":
				formID			= 'newSupplierForm';
				relationType	= 'supplier';
				getForm			= true;
				break;
			default :
				getForm = false;
				break;
		}

		if(getForm && $('#'+formID).find('input').length == 0){

			Third.loadPieceForForm(formID, relationType, 'document', undefined, more);

		} else if(!getForm){
			$('.newDocForm').slideUp(200);
			$('.newThirdForm').slideUp(200).html('');
		}

		if(checked === "fromDoc") {
			$("#docnewfromDocform").slideDown(200, function(){
				MyFacture.customForm("#docnewfromDocform");
			});
		}

		if(checked === "fromPur") {
			$("#docnewfromPurform").slideDown(200, function(){
				MyFacture.customForm("#docnewfromPurform");
			});
		}

		return;


	},

	switchDoctypeConvert: function(elem, doctype) {

		$("#tokenDoctype").html("");

		$("#tokenDoctype").html('<input type="text" id="docnewfromDocid" name="docnewfromDocid" e_autodoc_max="1" e_autodoc="'+doctype+'" e_autodoc_searchonfocus="true" />');

		TokenInput.autoDocumentListing(elem,$(elem).attr('e_autodoc'), $(elem).attr('e_autodoc_max'), $(elem).attr('e_autodoc_searchonfocus'), $(elem).attr('e_autodoc_more'), $(elem).attr('e_autodoc_sel'), '', $(elem).attr('e_autodoc_context'));

	},

	switchThirdType: function(where){
		var id_text		= '';
		var root_text	= '';
		var root		= null;

		switch(where) {
			case "prospect" :
				id_text		= 'prospect';
				root_text	= '#docnewprospectform';
				root		= $('#docnewprospectform');
				break;
			case "client" :
				id_text		= 'client';
				root_text	= '#docnewthirdform';
				root		= $('#docnewthirdform');
				break;
			case "supplier" :
				id_text		= 'supplier';
				root_text	= '#docnewsupplierform';
				root		= $('#docnewsupplierform');
				break;
		}

		var field = null;
		if(root.find("input[name=doc"+ id_text + "_isPerson]").prop('checked')){
			root.find("#docThirdCorpFields").fadeOut(function(){
				root.find("#docThirdUserFields").fadeIn('fast',function(){
					MyFacture.customForm(root_text + ' #docThirdUserFields');
					Qtip.init();
				});
				root.find("#docThirdSendDiv").fadeIn(function(){
					MyFacture.customForm(root_text + ' #docThirdSendDiv');
				});
			});
		} else {
			root.find("#docthird_send").prop("checked", false);

			root.find("#docThirdSendDiv").fadeOut();
			root.find("#docThirdUserFields").fadeOut(function(){
				root.find("#docThirdCorpFields").fadeIn();
			});
		}

	},

	presetRateCategory : function(item,transform){
		if (transform == 'transform'){
			return; // Cas de transform à partir d'un modèle
		}
		if (!item.rateCategory) {
			return;
		}
		var $option = $("select[name=docratecategory] option[value=" +item.rateCategory+ "]");
		if (!$option.length) {
			return
		}
		if (!$option.prop('disabled')) {
			$("select[name=docratecategory]").val(item.rateCategory);
		}
		var doctype = $("#docCreateForThirdForm input[name=doctype]").val();
		DocTools.setLayoutForRC($("#docCreateForThirdForm select[name=docratecategory]"),doctype, item.rateCategory);
	},

	setLayoutForRC : function(elem, doctype, rateCategory) {

		switch (doctype) {
			case 'estimate' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutEstimate');
				break;
			case 'invoice' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutInvoice');
				break;
			case 'creditnote' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutCreditnote');
				break;
			case 'delivery' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutDelivery');
				break;
			case 'order' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutOrder');
				break;
			case 'proforma' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutProforma');
				break;
			case 'model' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutModel');
				break;
		}

		if(layoutId == 0){
			var docrateCategory = $('#docCreateForThirdForm select[name=docratecategory]').val();
			var data = {action: "updateLayoutFromNewDoc", doctype: doctype, docrateCategory : docrateCategory};

			MyFacture.post('doc', data, function(data) {
				if(data.layoutID == 0){
					$("#docCreateForThirdForm #doclayout").val(data.defaultLayoutCorp);
					$("#docCreateForThirdForm #doclanguage").val(data.langid);
				}else{
					$("#docCreateForThirdForm #doclayout").val(data.layoutID);
					$("#docCreateForThirdForm #doclanguage").val(data.langid);
				}
			}, "json");
		}
		else {
			var docrateCategory = $('#docCreateForThirdForm select[name=docratecategory]').val();
			var data = {
				action: "updateLayoutFromNewDoc",
				doctype: doctype,
				docrateCategory: docrateCategory,
				layoutId: layoutId
			};

			MyFacture.post('doc', data, function (data) {
				$("#docCreateForThirdForm #doclayout").val(layoutId);
				$("#docCreateForThirdForm #doclanguage").val(data.langid);
			}, "json");
		}


		DocTools.setLangForLayout($("#docCreateForThirdForm select[name=doclayout]"));

	},

	setLangForLayout : function(elem) {

		var langId = elem.find("option:selected").attr('lang');

		if(langId == 0) langId = $("#doclanguage option[default='true']").val();

		$("#doclanguage").val(langId);
	},

	presetRateCategoryFrom : function(from) {
		if(from == 'newDoc'){
			var doctype = $('#doctype').val();
			var docrateCategory = $('#thirdNewDoc select[name=docratecategory]').val();
			var data = {action: "updateLayoutFromNewDoc", doctype: doctype, docrateCategory : docrateCategory};

			MyFacture.post('doc', data, function(data) {
				if(data.layoutID == 0){
					$("#thirdNewDoc #doclayout").val(data.defaultLayoutCorp);
					$("#thirdNewDoc #doclang").val(data.langid);
				}else{
					$("#thirdNewDoc #doclayout").val(data.layoutID);
					$("#thirdNewDoc #doclang").val(data.langid);
				}
			}, "json");
		}
		if(from == 'model'){
			var doctype = $('#docCreateForThirdForm select[name=doctype]').val();
			var docrateCategory = $('#docCreateForThirdForm input[name=rateCategoryModel]').val();
			var data = {action: "updateLayoutFromNewDoc", doctype: doctype, docrateCategory : docrateCategory};

			var radio = $('#docchoosethird');
			var label = radio.next('label');

			var newProspect = {
				field : $('#docnewprospect').parent(),
				form : $('#newProspectForm'),
			};

			if(doctype == "estimate"){
				newProspect.field.hasClass('hidden') && newProspect.field.removeClass('hidden').removeAttr('disabled');

				label.html(Loc.g('Pour un client / prospect existant'));
			} else {
				!newProspect.field.hasClass('hidden') && newProspect.field.addClass('hidden').attr('disabled', 'disabled');
				newProspect.form.slideUp(200);
				$('#docnewprospect').removeAttr('checked');
				$('#docchoosethird').attr('checked', true);
				DocTools.switchCreateForThird();

				label.html(Loc.g('Pour un client existant'));
			}

			MyFacture.post('doc', data, function(data) {
				if(data.layoutID == 0){
					$("#docCreateForThirdForm #doclayout").val(data.defaultLayoutCorp);
				}
				else{
					$("#docCreateForThirdForm #doclayout").val(data.layoutID);
				}
			}, "json");
		}

	},

	setRCFromNewDoc : function(elem) {
		var doctype = $('#doctype').val();

		switch (doctype) {
			case 'estimate' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutEstimate');
				break;
			case 'invoice' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutInvoice');
				break;
			case 'creditnote' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutCreditnote');
				break;
			case 'delivery' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutDelivery');
				break;
			case 'order' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutOrder');
				break;
			case 'proforma' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutProforma');
				break;
			case 'model' :
				var layoutId = elem.find("option:selected").attr('defaultLayoutModel');
				break;
		}

		if(layoutId == 0){
			rateCategory = $("#thirdNewDoc select[name=docratecategory]").val();
			var data = {action: "updateLayoutFromNewDoc", doctype: doctype, docrateCategory : rateCategory};

			MyFacture.post('doc', data, function(data) {
				if(data.layoutID == 0){
					$("#thirdNewDoc #doclayout").val(data.defaultLayoutCorp);
				}else{
					$("#thirdNewDoc #doclayout").val(data.layoutID);
				}
			}, "json");
		}
		else{
			$("#thirdNewDoc #doclayout").val(layoutId);
		}

		DocTools.setLangForLayout($("#thirdNewDoc select[name=doclayout]"));

	},


	checkDocSelected: function(el, type) {

		var docs = $(el).tokenInput("get");

		var call = type == "sales" ? 'doc' : 'purchases_purchases';

		if(docs.length > 0) {
			// a model is selected
			$('#updatePricesBlock').show();

			for(var i = 0;i < docs.length; i++) {
				var doc = docs[i];

				MyFacture.post(call, {
					action	: 'checkDocSelected',
					doc		: doc.id
				}, function(data) {

					$('.windowForm #useEcotaxe').prop('disabled', data.useEcotaxe == 'Y');

					// data.rateCategory
					if ($('#docratecategory option[value="'+data.rateCategory+'"]').length)
					{
						$('#docratecategory option').prop('selected', false).prop('disabled', true);
						$('#docratecategory option[value="'+data.rateCategory+'"]').prop('selected', true).prop('disabled', false);
						$('#docratecategory').trigger('change');
					}
				}, 'json');
			}
		} else {
			// no model is selected
			$('#updatePricesBlock').hide();
			$('.windowForm #useEcotaxe').prop('disabled', false);
			$('#docratecategory option').prop('disabled', false);
		}
		},

	deleteBonus: function(bonusId){
		if (confirm(Loc.g('Supprimer le bonus du document'))) {
			MyFacture.startWait()
			window.SellsyJS.WebServiceCaller.del(`/rest/docbonus/${bonusId}`, {}, (success) => {
				Utils.reload()
			}, (error) => {
				if (error?.response?.data?.error?.message) {
					Push.error(error?.response?.data?.error?.message);
				} else {
					Push.error(Loc.g("Une erreur s'est produite"));
				}
			}, (always) => {
				MyFacture.stopWait()
			});
		}
	},

};
